export default __webpack_public_path__ + "static/media/HeartFire.e2fa46bc.svg";